import { ColumnBoxFlexFullWidth } from '../common/boxes';
import { Link, Typography } from '@mui/material';
import { AUTH_PATH } from '../../router/paths';

const LinkExpired = () => {
  return (
    <ColumnBoxFlexFullWidth>
      <Typography variant={'h5'}>
        {'Your email verification link has expired'}
      </Typography>
      <Typography sx={{ my: 3 }}>
        {'Please '}
        <Link href={AUTH_PATH} color={'secondary'} sx={{fontWeight: 500}}>
          {'Login'}
        </Link>
        {' or use the '}
        <Link href={AUTH_PATH + '/forgot-password'} color={'secondary'} sx={{fontWeight: 500}}>
          {'Forgot Password'}
        </Link>
        {' page to send a new link.'}
      </Typography>
    </ColumnBoxFlexFullWidth>
  );
};

export default LinkExpired;